var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-warning float-right hidden-print",on:{"click":function($event){return _vm.print()}}},[_c('i',{staticClass:"fas fa-print"}),_vm._v(" "+_vm._s(_vm.printButtonName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }